import api from '@/lib/api';

const KEY = 'spoergmig_provider_referral';
let pending;
let memory;
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null') || memory; } catch { return memory; }
};

export function captureReferral(search = window.location.search) {
  const code = new URLSearchParams(search).get('ref');
  if (!code || !/^[A-Za-z0-9_-]{12,64}$/.test(code)) return Promise.resolve();
  if (pending) return pending;
  const existing = read();
  // First valid invitation wins for 30 days. The server checks its own expiry.
  if (existing?.token && existing.expires > Date.now()) return Promise.resolve();
  pending = api.post('/referrals/attribution', { code }).then(({ data }) => {
    memory = { token: data.token, expires: Date.now() + 30 * 86400000 };
    try { localStorage.setItem(KEY, JSON.stringify(memory)); } catch { /* Storage can be disabled. */ }
  }).finally(() => { pending = null; });
  return pending;
}

export async function referralToken() {
  await captureReferral().catch(() => {});
  if (pending) await pending.catch(() => {});
  const saved = read();
  return saved?.expires > Date.now() ? saved.token : undefined;
}

export function clearReferral() {
  memory = null;
  try { localStorage.removeItem(KEY); } catch { /* Storage can be disabled. */ }
}
